import React from "react";

const TermsAndConditions = () => (
  <div className="min-h-screen pt-28 sm:pt-32 bg-gray-900 text-white px-4 sm:px-6 lg:px-8 py-8 max-w-4xl mx-auto">
    <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-8 text-teal-400 border-b border-teal-600 pb-4">
      Terms and Conditions
    </h1>

    <p>Welcome to <strong>MEHAR TRADERS INTERNATIONAL LTD</strong> (“we,” “our,” “us”).</p>
    <p>This website is operated by a Private Limited Company registered in the United Kingdom.</p>
    <p><strong>Registered Office:</strong> 63 Orchard Grove, Harrow, United Kingdom, HA3 9QR</p>
    <p><strong>Company Status:</strong> Active</p>
    <p><strong>Company Type:</strong> Private Limited Company</p>
    <p><strong>Incorporated on:</strong> 23 January 2024</p>

    <p>By accessing and using our website, you agree to comply with and be bound by the following Terms and Conditions. Please read them carefully.</p>

    <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-2">1. Definitions</h2>
    <ul className="list-disc list-inside mb-4">
      <li><strong>Website:</strong> Refers to Mehar Traders’ website.</li>
      <li><strong>User:</strong> Anyone accessing or using the website.</li>
      <li><strong>Products:</strong> Goods offered for sale on the website.</li>
    </ul>

    <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-2">2. Acceptance of Terms</h2>
    <p>By using this website, you agree to these Terms and Conditions. If you do not agree, please do not use the website.</p>

    <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-2">3. Orders</h2>
    <h3 className="text-lg sm:text-xl font-semibold mt-4 mb-1">3.1 Placing Orders</h3>
    <ul className="list-disc list-inside mb-2">
      <li>Orders can be placed through our website by registered users only.</li>
      <li>You must be 18 years or older, reachable by telephone, and have a valid email address to place an order.</li>
      <li>All orders are subject to availability and acceptance. By placing an order, you make an offer to purchase the selected products under these Terms.</li>
      <li>MEHAR TRADERS INTERNATIONAL LTD may refuse or reduce your order at our discretion. Once submitted, orders are binding and cannot be cancelled or amended.</li>
      <li>Product images, colours, and sizes displayed on the website may differ from the actual product.</li>
    </ul>

    <h3 className="text-lg sm:text-xl font-semibold mt-4 mb-1">3.2 Pricing</h3>
    <p>Prices are displayed in GBP and exclude VAT unless otherwise stated. We reserve the right to change prices at any time without notice.</p>

    <h3 className="text-lg sm:text-xl font-semibold mt-4 mb-1">3.3 Payment</h3>
    <ul className="list-disc list-inside mb-2">
      <li>Payment must be made at the time of order via the methods provided.</li>
      <li>Payments must be made in the currency indicated on your invoice.</li>
      <li>If paying by credit or debit card, you must provide valid card details. We will not dispatch products until payment is authorised.</li>
      <li>We may request additional documentation to verify cardholder identity.</li>
    </ul>

    <h3 className="text-lg sm:text-xl font-semibold mt-4 mb-1">3.4 Order Confirmation</h3>
    <p>You will receive an email confirmation once your order is placed. Acceptance of your order is confirmed only when we dispatch the goods.</p>

    <h3 className="text-lg sm:text-xl font-semibold mt-4 mb-1">3.5 Debt Collection</h3>
    <p>Unless otherwise agreed in writing, all invoices must be paid within the agreed payment terms. If an invoice remains unpaid and becomes more than 60 days overdue, we may instruct third-party debt collection agencies. Any costs incurred will be added to the outstanding amount.</p>

    <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-2">4. Delivery</h2>
    <ul className="list-disc list-inside mb-2">
      <li><strong>Delivery Times:</strong> Estimated delivery times are provided at checkout and may vary based on location and stock availability.</li>
      <li><strong>Delivery Charges:</strong> Calculated and displayed at checkout.</li>
      <li><strong>Risk of Loss:</strong> Passes to you upon delivery. For full details, review our Delivery and Returns Policy.</li>
    </ul>

    <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-2">5. Returns and Refunds</h2>
    <ul className="list-disc list-inside mb-2">
      <li><strong>Returns:</strong> Products can be returned within 14 days of delivery. Items must be unopened, unused, and in original packaging. Some items may be non-returnable due to hygiene or safety concerns.</li>
      <li><strong>Refunds:</strong> Processed within 14 days of receiving returned items. Shipping costs are non-refundable unless the return is due to our error. See our Returns Policy for details.</li>
    </ul>

    <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-2">6. User Accounts</h2>
    <ul className="list-disc list-inside mb-2">
      <li><strong>Account Registration:</strong> Registration is required to place orders. Provide accurate information.</li>
      <li><strong>Account Security:</strong> You are responsible for keeping your account secure. Notify us immediately of any unauthorised access.</li>
    </ul>

    <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-2">7. Intellectual Property</h2>
    <p>All content on this website (text, images, logos, software) is owned by MEHAR TRADERS INTERNATIONAL LTD or our licensors. Reproduction or use without written consent is prohibited.</p>

    <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-2">8. Limitation of Liability</h2>
    <p>We are not liable for indirect, incidental, or consequential damages arising from your use of the website. Maximum liability is limited to the amount you paid for the products in question.</p>

    <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-2">9. Third-Party Links</h2>
    <p>Our website may contain links to third-party sites. We are not responsible for their content or practices.</p>

    <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-2">10. Termination</h2>
    <p>We may suspend or terminate your website access if you violate these Terms and Conditions.</p>

    <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-2">11. Governing Law</h2>
    <p>These Terms are governed by the laws of England and Wales. Any disputes will be resolved exclusively in the courts of England and Wales.</p>

    <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-2">12. Changes to Terms and Conditions</h2>
    <p>We reserve the right to update these Terms at any time. Changes will be posted on this page, and continued use constitutes acceptance.</p>

    <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-2">13. Related Policies</h2>
    <ul className="list-disc list-inside mb-2">
      <li>Privacy Policy</li>
      <li>Cookie Policy</li>
      <li>Delivery and Returns Policy</li>
    </ul>

    <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-2">14. Contact Us</h2>
    <p>If you have any questions about these Terms, please contact us:</p>
    <p>
      <strong>MEHAR TRADERS INTERNATIONAL LTD</strong><br/>
      63 Orchard Grove, Harrow, United Kingdom, HA3 9QR<br/>
      Email: <a href="mailto:info@mehartraders.co.uk" className="text-teal-300 hover:text-teal-200 underline">info@mehartraders.co.uk</a> or{" "}
      <a href="mailto:hello@mehartradersinternational.co.uk" className="text-teal-300 hover:text-teal-200 underline">hello@mehartradersinternational.co.uk</a><br/>
      Phone: +44 7448 739174
    </p>

    <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-2">15. Third-Party Trademarks and Logos</h2>
    <p>All third-party trademarks, product names, brand logos, and images are the property of their respective owners. Use of these logos is strictly for identifying products and does not imply affiliation or endorsement.</p>

    <p className="mt-6">Thank you for choosing <strong>MEHAR TRADERS INTERNATIONAL LTD</strong>. Your trust means everything to us.</p>
  </div>
);

export default TermsAndConditions;
